<template>
  <div>
    <h1 class="title">Vuoi dare un tocco in più alla sua pappa?</h1>

    <p class="subtitle">
      <strong
        >Abbiamo tutto quello che
        <span v-if="showNumberOfDogs">i tuoi "pelosi" desiderano</span
        ><span v-else> {{ dogData.name | capitalize }} desidera!</span></strong
      ><br />
      Infatti potrai farlo sentire <strong>COME AL RISTORANTE</strong> scegliendo un gusto
      e un ingrediente extra!
    </p>

    <form @submit.prevent>
      <div class="form grid grid-cols-1 md:grid-cols-2 gap-12">
        <div class="form-group">
          <label class="form-label important-label"> Desideri una proteina extra? </label>
          <div class="additional-info">
            Se
            <span v-if="showNumberOfDogs">i tuoi "pelosi" sono schizzinosi </span
            ><span v-else>{{ dogData.name | capitalize }} è schizzinoso </span>
            <strong>aggiungi un'altra ricetta così da alternarne</strong> <br />
            ogni giorno tra le due ricette scelte e renderlo ancora più felice.
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
            <label
              v-for="recipe in recipes"
              :key="recipe.id"
              :class="[dog.isDoubleTaste == recipe.id ? 'checked' : 'unchecked']"
              class="option-radio option-icon"
              :for="['doubletaste-' + recipe.id]"
            >
              <input
                @click="handleDoubleTasteSelection(recipe.id)"
                class="hidden"
                type="checkbox"
                :id="['doubletaste-' + recipe.id]"
                :value="recipe.id"
              />
              <div class="text-left leading-5">
                <div class="option-label">
                  {{ recipe.title.rendered }}
                </div>
              </div>
              <img
                class="w-12 h-12 object-contain object-center"
                :src="recipe.toolsetMeta.recipesDetails.recipeMainIngredientIcon.raw"
              />
            </label>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label important-label">
            Vuoi aggiungere qualche ingrediente extra?
          </label>
          <div class="additional-info">
            SuperFood
            <strong
              >per migliorare ancora di più <br />la pappa
              <span v-if="showNumberOfDogs">dei tuoi "pelosi"</span
              ><span v-else>di {{ dogData.name | capitalize }}</span
              >!</strong
            >
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
            <!-- :class="[dog.extraIngredientIds == 110 ? 'checked' : 'unchecked']" -->
            <label
              v-for="extraIngredient in extraIngredients"
              :key="extraIngredient.id"
              :class="[
                dog.extraIngredientIds.includes(extraIngredient.id)
                  ? 'checked'
                  : 'unchecked',
              ]"
              class="option-radio option-icon"
            >
              <input
                v-model.number="$v.dog.extraIngredientIds.$model"
                class="hidden"
                type="checkbox"
                :id="extraIngredient.id"
                :value="extraIngredient.id"
              />
              <div class="text-left">
                <div class="option-label">
                  {{ extraIngredient.name }}
                </div>
                <a
                  class="text-xs text-red-600 block"
                  v-on:click="showMore(extraIngredient.id)"
                  href="#"
                  >Perché aggiungerle?</a
                >
              </div>
              <img class="h-12 w-12" :src="extraIngredient.postThumbnailUrl" />
            </label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label important-label">
          Cosa ne pensi di un po' di verdura di stagione?
        </label>
        <div
          class="switch-container big max-w-lg"
          :class="[dog.seasonalVegetables == null ? 'switch-empty' : '']"
        >
          <label
            for="seasonal_vegetables_yes"
            class="switch-option"
            :class="[dog.seasonalVegetables == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.seasonalVegetables.$model"
              class="hidden"
              type="radio"
              id="seasonal_vegetables_yes"
              value="1"
            />
            <span>Sì mi piace l'idea</span>
          </label>
          <label
            for="seasonal_vegetables_no"
            class="switch-option"
            :class="[dog.seasonalVegetables == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.seasonalVegetables.$model"
              class="hidden"
              type="radio"
              id="seasonal_vegetables_no"
              value="0"
            />
            <span>Magari la prossima volta</span>
          </label>
        </div>
        <div class="additional-info">
          Selezioneremo <strong>gratuitamente</strong> verdure di stagione per una
          freschezza ed un valore biologico senza pari perfettamente bilanciate ed
          integrate nella
          <span v-if="showNumberOfDogs">loro</span>
          <span v-else>sua</span>
          dieta.
        </div>

        <div v-if="$v.dog.seasonalVegetables.$error" class="error">
          campo obbligatorio
        </div>
      </div>
      <transition
        enter-class="opacity-0 scale-75"
        enter-to-class="opacity-100 scale-100"
        enter-active-class="transition-all duration-300 ease-out"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-75"
        leave-active-class="transition-all duration-400 ease-in"
      >
        <div
          v-if="showModal"
          class="fixed inset-0 flex items-center justify-center z-10 w-full md:w-10/12"
        >
          <div v-on:click="closeModal()" class="absolute inset-0 bg-white bg-opacity-75">
            &nbsp;
          </div>
          <div
            class="relative bg-gray-50 rounded-2xl p-6 max-w-xs max-h-[50vh] overflow-y-auto md:max-h-screen md:max-w-sm w-full shadow-lg text-left"
          >
            <a
              class="cursor-pointer absolute text-red-600 top-2 right-2 rounded-full flex items-center justify-center p-1"
              v-on:click="closeModal()"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </a>
            <h3 class="text-red-600 font-bold text-xl">
              {{ ingredientDetails.name }}
            </h3>
            <div
              class="text-gray-700 text-sm flex gap-4 items-center whitespace-pre-line"
            >
              {{ ingredientDetails.description }}
              <img class="h-16 w-16" :src="ingredientDetails.postThumbnailUrl" />
            </div>
          </div>
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      recipes: [],
      prices: [],
      extraIngredients: [],
      ingredientDetails: [],
      showModal: "",
      dog: {
        isDoubleTaste: null,
        seasonalVegetables: null,
        extraIngredientIds: [],
      },
    };
  },
  validations: {
    dog: {
      isDoubleTaste: {
        required: false,
      },
      seasonalVegetables: {
        required,
      },
      extraIngredientIds: {
        // required: false
      },
    },
  },
  watch: {
    dog: {
      deep: true,
      handler: "getPrices",
    },
  },
  computed: {
    showNumberOfDogs() {
      return this.wizardData.numberOfDogs > 1 && this.wizardData.sameDiet;
    },
  },
  methods: {
    handleDoubleTasteSelection(item) {
      if (this.dog.isDoubleTaste == item) {
        this.dog.isDoubleTaste = null;
      } else {
        this.dog.isDoubleTaste = item;
      }
    },
    showMore(id) {
      this.showModal = id;
      this.ingredientDetails = this.extraIngredients.filter((ingredient) => {
        return ingredient.id == this.showModal;
      })[0];
    },
    closeModal() {
      this.showModal = "";
      this.ingredientDetails = [];
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              isDoubleTaste: this.dog.isDoubleTaste,
              seasonalVegetables: this.dog.seasonalVegetables,
              extraIngredientIds: this.dog.extraIngredientIds,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    getExtraIngredients() {
      this.extraIngredients = this.listData.extraIngredients;
    },
    getAllergyIds() {
      let allergyIds = [];
      if (this.wizardData.numberOfDogs >= 2 && this.wizardData.sameDiet) {
        this.wizardData.dogs.map(function (dog) {
          allergyIds.push(dog["allergyIds"]);
        });
      } else allergyIds = this.dogData.allergyIds;
      return allergyIds.join();
    },
    getRecipes() {
      let allergyIds = this.getAllergyIds();
      // filter by food preparation method and exclude main recipe
      let recipes = this.listData.recipes.filter(
        (recipe) =>
          recipe.foodPreparationMethod == this.wizardData.foodPreparationMethodId &&
          parseInt(recipe.id) != parseInt(this.dogData.recipeId)
      );
      // filter by allergies
      this.recipes = recipes.filter(
        (recipe) =>
          !recipe.ingredient.some((ingredient) => allergyIds.includes(ingredient))
      );
    },
    async getPrices() {
      this.$emit("barAsyncState", "pending");

      if (this.dog.extraIngredientIds.includes(null)) {
        this.dog.extraIngredientIds = [];
      }

      var updatedData = [],
        dog = [];
      updatedData = Object.assign({}, this.wizardData);

      // get prices to only one dog if different diet
      // otherwise get prices to all
      if (this.wizardData.numberOfDogs >= 2 && !this.wizardData.sameDiet) {
        updatedData.numberOfDogs = 1;
        updatedData.dogs = [];
        dog = Object.assign(this.dogData, this.dog);
        updatedData.dogs.push(dog);
      } else if (this.wizardData.numberOfDogs >= 2 && this.wizardData.sameDiet) {
        // first needs to update all dogs with isDoubleTaste, oilSlug, extraIngredientIds, seasonalVegetables
        for (let i = 0; i < this.wizardData.numberOfDogs; i++) {
          Object.assign(updatedData.dogs[i], this.dog);
        }
      } else {
        Object.assign(updatedData.dogs[updatedData.indexDog], this.dog);
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          snakecaseKeys({
            form: updatedData,
            selectedRecipeId: this.dogData.recipeId,
          })
        ),
      };
      let url = this.$restAPIurlRB + "recipe-prices";
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      var camelcaseData = camelcaseKeys(data, { deep: true });
      this.prices = camelcaseData.recipes;
      this.$emit("prices", this.prices);
      this.$emit("barAsyncState", "success");
    },
  },
  activated() {
    this.getExtraIngredients();
    this.dog.isDoubleTaste = this.dogData.isDoubleTaste;
    this.dog.seasonalVegetables = this.dogData.seasonalVegetables;
    this.dog.extraIngredientIds = this.dogData.extraIngredientIds;
    this.$v.$reset();
    this.getRecipes();
    this.getPrices();
  },
  mounted() {
    this.getExtraIngredients();
    this.getRecipes();
    this.getPrices();
  },
};
</script>
